import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const DocumentTemplatePage_SaveDocumentTemplatePreview_Mutation =
  graphql(`
    mutation DocumentTemplatePage_SaveDocumentTemplatePreview(
      $printableId: Id!
      $versionData: VersionDataInput
    ) {
      saveDocumentTemplatePreview(
        printableId: $printableId
        versionData: $versionData
      ) {
        ...PrinterContextProvider_PdfPrint_Fragment
      }
    }
  `);

export type SaveDocumentTemplatePreview_Result = ResultOf<
  typeof DocumentTemplatePage_SaveDocumentTemplatePreview_Mutation
>;

export const useSavePreviewMutation = () =>
  useGraphQLMutation(DocumentTemplatePage_SaveDocumentTemplatePreview_Mutation);
